var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderEmptyIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFF1DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 36,
    r: 12,
    fill: "#FFA001"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 24.0928C34.9914 24.0316 35.492 24 36 24C42.6274 24 48 29.3726 48 36C48 42.6274 42.6274 48 36 48C29.3726 48 24 42.6274 24 36C24 33.1622 24.9851 30.5544 26.6319 28.5",
    stroke: "#003B6F",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32V36L40 40",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0312 19.9688L32.9974 24.0026L37.0312 28.0364",
    stroke: "#003B6F",
    strokeWidth: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEmptyIconOrange);
export default __webpack_public_path__ + "static/media/OrderEmptyIconOrange.e2822e2de3ca469423f1bdbb8814f2f8.svg";
export { ForwardRef as ReactComponent };